import moment from "moment-timezone";
import { APStatus } from "../constant/assistanceProgram";

/**
 * Display filter map for notifications
 * Each filter contains:
 * - key: unique identifier
 * - text: function that returns localized text
 * - filter: function that filters notification list
 */
export const DisplayFilterMap = Object.freeze({
  unread: {
    key: "unread",
    text: (t) => t("notifications.display_filter.unread_notifications"),
    filter: (list) =>
      list.filter((notification) => !notification.read && notification.assistanceProgram.status !== APStatus.CLOSED)
  },
  relevant: {
    key: "relevant",
    text: (t) => t("notifications.display_filter.open_with_relevant_patients"),
    filter: (list) =>
      list.filter(
        (notification) => notification.hasTopOppsPatients && notification.assistanceProgram.status !== APStatus.CLOSED
      )
  },
  recentlyOpened: {
    key: "recentlyOpened",
    text: (t) => t("notifications.display_filter.recently_opened_programs"),
    filter: (list) =>
      list.filter(
        (notification) =>
          notification.assistanceProgram.status === APStatus.OPEN &&
          moment(notification.createdAt).isAfter(moment().subtract(7, "d"))
      )
  },
  closed: {
    key: "closed",
    text: (t) => t("notifications.display_filter.closed_programs"),
    filter: (list) => list.filter((notification) => notification.assistanceProgram.status === APStatus.CLOSED)
  },
  all: {
    key: "all",
    text: (t) => t("notifications.display_filter.all_programs"),
    filter: (list) => list,
    sort: (list) => list
  }
});

/**
 * Apply a display filter to a list of notifications
 * @param {Array} notifications - The list of notifications to filter
 * @param {string} filterKey - The key of the filter to apply (e.g., 'unread', 'relevant')
 * @returns {Array} The filtered list of notifications
 */
export const applyNotificationFilter = (notifications, filterKey = "unread") => {
  const filter = DisplayFilterMap[filterKey];
  if (!filter) {
    console.warn(`Unknown filter key: ${filterKey}, using 'unread' as default`);
    return DisplayFilterMap.unread.filter(notifications);
  }
  return filter.filter(notifications);
};

/**
 * Calculate the unread count from a list of notifications
 * @param {Array} notifications - The list of notifications
 * @returns {number} The count of unread notifications
 */
export const getUnreadCount = (notifications) => {
  return notifications.filter((notification) => !notification.read).length;
};
